import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormGroup, Label } from 'reactstrap';
import FormModal from '../../../components/modals/FormModal';
import LandlordSearchInput from '../../../components/landlordInvestors/LandlordSearchInput';
import ModelUnitListSelector from '../../../components/projects/ModelUnitListSelector';
import { ModelUnit } from '../../../models/modelUnitModel';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { createPreBookingEndpoint } from '../services/prebookingService';

interface Props {
  projectId: string;
  isOpen: boolean;
  onToggle: () => void;
}

const CreatePreBookingModal = ({ projectId, isOpen, onToggle }: Props) => {
  const navigate = useNavigate();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const { callEndpoint } = useCallApiAndLoad();

  const [unitId, setUnitId] = useState<string>();
  const [landlordId, setLandlordId] = useState<string>();

  const handleUnitSelected = (unit: ModelUnit) => {
    setUnitId(unit.unit_id);
  };

  const handleLandlordFound = (id: string) => {
    setLandlordId(id);
  };

  const handleReset = () => {
    setUnitId(undefined);
    setLandlordId(undefined);
  };

  const handleSubmit = async () => {
    if (!unitId || !landlordId) return;
    const { status } = await callEndpoint(
      createPreBookingEndpoint({ unit_id: unitId, landlord_id: landlordId }, token),
    );
    if (status === 201) {
      handleReset();
      onToggle();
      navigate(0);
    }
  };

  return (
    <FormModal
      headerText="Crear pre-reserva"
      isOpen={isOpen}
      onToggle={onToggle}
      onReset={handleReset}
      onConfirmation={handleSubmit}
      confirmationText="Crear pre-reserva"
      size="lg"
    >
      <>
        <FormGroup>
          <Label>Unidad</Label>
          <ModelUnitListSelector
            projectId={projectId}
            onModelUnitSelected={handleUnitSelected}
          />
        </FormGroup>
        <FormGroup>
          <LandlordSearchInput
            header="Buscar inversionista"
            onLandlordfound={handleLandlordFound}
          />
        </FormGroup>
      </>
    </FormModal>
  );
};

export default CreatePreBookingModal;
